export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    platform: [
      { label: 'Challenges', href: 'https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco' },
      { label: 'Pricing', href: 'https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco' },
      { label: 'Dashboard', href: 'https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco' },
      { label: 'Leaderboard', href: 'https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco' }
    ],
    resources: [
      { label: 'Trading Rules', href: 'https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco' },
      { label: 'FAQ', href: '#faq' },
      { label: 'Blog', href: 'https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco' },
      { label: 'Support', href: 'https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco' }
    ],
    legal: [
      { label: 'Terms of Service', href: 'https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco' },
      { label: 'Privacy Policy', href: 'https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco' },
      { label: 'Risk Disclosure', href: 'https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco' },
      { label: 'Refund Policy', href: 'https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco' }
    ]
  };

  const socialLinks = [
    { icon: 'ri-twitter-x-line', href: 'https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco', label: 'Twitter' },
    { icon: 'ri-discord-line', href: 'https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco', label: 'Discord' },
    { icon: 'ri-telegram-line', href: 'https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco', label: 'Telegram' },
    { icon: 'ri-youtube-line', href: 'https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco', label: 'YouTube' }
  ];

  return (
    <footer className="bg-gradient-to-br from-[#0D1B2A] via-[#0A1628] to-[#1a0b2e] text-white relative overflow-hidden">
      {/* World Map Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(255,255,255,0.15) 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }}></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
        {/* Upper Section */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <img 
              src="https://public.readdy.ai/ai/img_res/bcb95e27-fe0e-4195-af23-4243a6196df3.png" 
              alt="QT Funded Logo" 
              className="h-12 w-auto mb-6"
            />
            <p className="text-gray-400 text-lg mb-6 leading-relaxed">
              Empowering traders worldwide with industry-leading funded accounts and unmatched support.
            </p>
            
            {/* Newsletter */}
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 bg-white/10 border border-white/20 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:border-cyan-500 transition-colors"
              />
              <button className="px-6 py-3 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-xl hover:shadow-lg hover:shadow-cyan-500/50 transition-all duration-300 flex items-center justify-center cursor-pointer whitespace-nowrap">
                <i className="ri-send-plane-fill text-xl"></i>
              </button>
            </div>
          </div>

          {/* Platform Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Platform</h3>
            <ul className="space-y-3">
              {footerLinks.platform.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Resources</h3>
            <ul className="space-y-3">
              {footerLinks.resources.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Legal</h3>
            <ul className="space-y-3">
              {footerLinks.legal.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-white/20 to-transparent mb-8"></div>

        {/* Lower Section */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Copyright */}
          <p className="text-gray-400 text-sm">
            © {currentYear} QT Funded. All rights reserved.
          </p>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                className="w-10 h-10 border-2 border-white/20 rounded-lg flex items-center justify-center hover:border-cyan-500 hover:bg-cyan-500/10 transition-all duration-300 cursor-pointer"
              >
                <i className={`${social.icon} text-xl`}></i>
              </a>
            ))}
          </div>

          {/* Legal Links */}
          <div className="flex items-center gap-4 text-sm text-gray-400">
            <a href="https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco" className="hover:text-cyan-400 transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <span>|</span>
            <a href="https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco" className="hover:text-cyan-400 transition-colors cursor-pointer">
              Terms of Service
            </a>
          </div>
        </div>

        {/* Readdy Attribution */}
        <div className="mt-8 text-center">
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-500 text-sm hover:text-cyan-400 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
